function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.25,
    height: 14.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.072857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 7.255
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.51,
    width: 26.25,
    height: 19.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 24.060000000000002
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.61,
    width: 26.25,
    height: 20.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 43.665
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.72,
    width: 26.25,
    height: 28.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 68.065
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.42,
    width: 26.25,
    height: 32.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 98.485
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.55,
    width: 26.25,
    height: 33.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9166666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 131.07
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.59,
    width: 26.25,
    height: 33.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 164.33
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 181.06,
    width: 26.25,
    height: 33.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 197.805
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.55,
    width: 26.25,
    height: 33.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 231.38
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.21,
    width: 26.25,
    height: 35.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 266.05
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.89,
    width: 26.25,
    height: 38.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 302.925
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 321.96,
    width: 26.25,
    height: 41.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 342.91999999999996
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.88,
    width: 26.25,
    height: 43.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 385.51
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.14,
    width: 26.25,
    height: 45.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9166666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 429.925
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 452.71,
    width: 26.25,
    height: 45.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 475.63
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 498.55,
    width: 26.25,
    height: 45.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 521.485
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 544.42,
    width: 26.25,
    height: 48.52,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 568.68
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.94,
    width: 26.25,
    height: 51.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 618.705
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.47,
    width: 26.25,
    height: 55.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.125,
    y: 672.235
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 0,
    width: 36.52,
    height: 43.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.086666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.510000000000005,
    y: 21.855
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 0,
    width: 36.65,
    height: 43.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.235714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.095,
    y: 21.855
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.42,
    y: 0,
    width: 36.79,
    height: 43.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.815,
    y: 21.855
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.21,
    y: 0,
    width: 38.6,
    height: 43.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.51000000000002,
    y: 21.855
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 0,
    width: 38.8,
    height: 43.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.20000000000002,
    y: 21.855
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.61,
    y: 0,
    width: 39.36,
    height: 43.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.29000000000002,
    y: 21.855
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.97,
    y: 0,
    width: 42.59,
    height: 43.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.871818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.265,
    y: 21.855
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.56,
    y: 0,
    width: 42.67,
    height: 43.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.33375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.895,
    y: 21.855
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.23,
    y: 0,
    width: 42.9,
    height: 43.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.68,
    y: 21.855
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.13,
    y: 0,
    width: 43.25,
    height: 43.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.755,
    y: 21.855
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.38,
    y: 0,
    width: 43.65,
    height: 43.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2749999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.205,
    y: 21.855
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.03,
    y: 0,
    width: 44.4,
    height: 43.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.22999999999996,
    y: 21.855
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.42,
    y: 0,
    width: 45.73,
    height: 43.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.46375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.285,
    y: 21.855
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.15,
    y: 0,
    width: 46.71,
    height: 43.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.371
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.505,
    y: 21.855
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.86,
    y: 0,
    width: 46.98,
    height: 43.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.35,
    y: 21.855
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.84,
    y: 0,
    width: 48.16,
    height: 43.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.371
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.9200000000001,
    y: 21.855
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 43.71,
    width: 52.24,
    height: 42.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.066666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 64.91
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 86.11,
    width: 52.24,
    height: 45.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.65375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 108.725
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 131.34,
    width: 52.24,
    height: 45.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.072
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 154.02
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 176.71,
    width: 52.24,
    height: 46.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.121111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 199.755
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 222.8,
    width: 52.24,
    height: 47.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.456
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 246.44
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 270.08,
    width: 52.24,
    height: 49.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.094166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 294.645
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 319.21,
    width: 52.24,
    height: 49.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.021428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 343.78499999999997
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 368.36,
    width: 52.24,
    height: 49.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 393.035
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 417.72,
    width: 52.24,
    height: 52.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 444.14500000000004
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 470.57,
    width: 52.24,
    height: 55.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.804444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 498.435
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 526.3,
    width: 52.24,
    height: 56.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 554.665
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 583.03,
    width: 52.24,
    height: 58.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 612.265
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 641.5,
    width: 52.24,
    height: 58.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.370000000000005,
    y: 670.75
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 43.71,
    width: 50.46,
    height: 62.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.208571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.72,
    y: 74.74000000000001
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 43.71,
    width: 50.55,
    height: 62.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.225,
    y: 74.74000000000001
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 43.71,
    width: 50.94,
    height: 62.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.277142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.97,
    y: 74.74000000000001
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.45,
    y: 43.71,
    width: 52.04,
    height: 62.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.782222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.46999999999997,
    y: 74.74000000000001
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.49,
    y: 43.71,
    width: 54.86,
    height: 62.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.92,
    y: 74.74000000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.35,
    y: 43.71,
    width: 54.99,
    height: 62.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.165000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.845,
    y: 74.74000000000001
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.34,
    y: 43.71,
    width: 59.78,
    height: 62.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.963333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.22999999999996,
    y: 74.74000000000001
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.12,
    y: 43.71,
    width: 60.85,
    height: 62.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.60625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.545,
    y: 74.74000000000001
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 43.71,
    width: 60.99,
    height: 62.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.776666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.455,
    y: 74.74000000000001
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.96,
    y: 43.71,
    width: 62.33,
    height: 62.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.865714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.125,
    y: 74.74000000000001
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.29,
    y: 43.71,
    width: 63.71,
    height: 62.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.145,
    y: 74.74000000000001
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 105.77,
    width: 67.65,
    height: 60.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 135.92
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 166.07,
    width: 67.65,
    height: 62.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.76625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 197.135
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 228.2,
    width: 67.65,
    height: 64.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.237142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 260.53
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 292.86,
    width: 67.65,
    height: 64.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 325.28000000000003
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 357.7,
    width: 67.65,
    height: 65.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.848333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 390.245
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 422.79,
    width: 67.65,
    height: 66.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 456.19
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 489.59,
    width: 67.65,
    height: 68.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 523.89
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 558.2,
    width: 67.65,
    height: 69.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 593.1750000000001
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 628.15,
    width: 67.65,
    height: 71.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.315,
    y: 664.0749999999999
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 105.77,
    width: 64.66,
    height: 76.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.931999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.46999999999997,
    y: 143.79
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.8,
    y: 105.77,
    width: 65.72,
    height: 76.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.66000000000003,
    y: 143.79
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.52,
    y: 105.77,
    width: 67.13,
    height: 76.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.425999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.085,
    y: 143.79
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.65,
    y: 105.77,
    width: 67.61,
    height: 76.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.9025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.455,
    y: 143.79
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.26,
    y: 105.77,
    width: 69.82,
    height: 76.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.636666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.16999999999996,
    y: 143.79
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.08,
    y: 105.77,
    width: 72.47,
    height: 76.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.05875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.3149999999999,
    y: 143.79
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.55,
    y: 105.77,
    width: 72.93,
    height: 76.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.586000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.015,
    y: 143.79
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.48,
    y: 105.77,
    width: 73.52,
    height: 76.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.168888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.24,
    y: 143.79
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 181.81,
    width: 76.1,
    height: 81.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 222.665
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 263.52,
    width: 76.1,
    height: 83.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 305.46
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 347.4,
    width: 76.1,
    height: 84.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.683333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 389.645
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 431.89,
    width: 76.1,
    height: 86.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.455555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 475.23
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 518.57,
    width: 76.1,
    height: 87.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.609999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 562.4250000000001
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 606.28,
    width: 76.1,
    height: 93.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.219999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.19,
    y: 653.14
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.24,
    y: 181.81,
    width: 75.23,
    height: 95.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.40375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.855,
    y: 229.61
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.48,
    y: 181.81,
    width: 76.75,
    height: 95.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.855,
    y: 229.61
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.23,
    y: 181.81,
    width: 77.23,
    height: 95.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.871666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.845,
    y: 229.61
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.46,
    y: 181.81,
    width: 78.46,
    height: 95.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.208571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.69,
    y: 229.61
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.91,
    y: 181.81,
    width: 83.07,
    height: 95.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.38375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.4449999999999,
    y: 229.61
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.99,
    y: 181.81,
    width: 87.01,
    height: 95.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 656.495,
    y: 229.61
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.24,
    y: 277.4,
    width: 91.9,
    height: 96.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.19,
    y: 325.42499999999995
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.24,
    y: 373.45,
    width: 91.9,
    height: 96.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.380000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.19,
    y: 421.48
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.24,
    y: 469.51,
    width: 91.9,
    height: 113.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.12857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.19,
    y: 526.225
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.24,
    y: 582.94,
    width: 91.9,
    height: 117.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.19,
    y: 641.47
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.14,
    y: 277.4,
    width: 121.33,
    height: 93.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.306999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.805,
    y: 323.93499999999995
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.47,
    y: 277.4,
    width: 130.39,
    height: 93.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.511666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.665,
    y: 323.93499999999995
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.87,
    y: 277.4,
    width: 134.13,
    height: 93.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.511666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.935,
    y: 323.93499999999995
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.14,
    y: 370.47,
    width: 113.67,
    height: 126.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.20875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.97499999999997,
    y: 433.92
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.14,
    y: 497.37,
    width: 113.67,
    height: 202.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.23857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.97499999999997,
    y: 598.685
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.81,
    y: 370.47,
    width: 133.18,
    height: 194.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.4,
    y: 467.925
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.99,
    y: 370.47,
    width: 139.01,
    height: 194.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.37625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.495,
    y: 467.925
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.81,
    y: 565.39,
    width: 272.19,
    height: 134.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.237272727272728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.905,
    y: 632.6949999999999
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.637b92318253cd67aa3f5afd75ebceda.svg";
export { ForwardRef as ReactComponent };